import { FETCH_STATUSES } from "enums";
import useUsers from "hooks/useUsers";
import useNotifications from "hooks/useNotifications";
import useMakes from "hooks/useMakes";
import useRouter from "hooks/useRouter";
import useGlobalLoading from "hooks/useGlobalLoading";
import UserPresenter from "presenters/UserPresenter";
import MakePresenter from "presenters/MakePresenter";
import { jjLogger, newRelic } from "utils/logUtils";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import { appRoutes } from "routes";

const useSaveMakeAndGo = (saveMakeSuccess, templateGroup, getLabel = null) => {
  const { saveMake, loadMake } = useMakes();
  const { ensureCurrentUser } = useUsers();
  const { addErrorNotification } = useNotifications();
  const { push } = useRouter();
  const { setStatus: setLoaderStatus } = useGlobalLoading(null, { labelFunction: getLabel, crossPage: true });

  const redirectTo = (make, currentUser) => {
    const makeViewPath = appRoutes.makeViewPath(templateGroup?.id, MakePresenter.id(make));
    const makePreviewPath = appRoutes.makePreviewPath(templateGroup?.id, MakePresenter.id(make));
    const signUpPath = appRoutes.signUpPath();
    if (UserPresenter.isAnonymous(currentUser) && TemplateGroupPresenter.isStraightUp(templateGroup)) {
      setLoaderStatus(FETCH_STATUSES.fulfilled);
      loadMake(make.id);
      return push({ pathname: signUpPath, state: { referrer: "inFlow" } });
    }

    if (UserPresenter.isAnonymous(currentUser)) {
      const path = MakePresenter.isDraft(make) ? makePreviewPath : signUpPath;
      if (path === signUpPath) setLoaderStatus(FETCH_STATUSES.fulfilled);
      return push({ pathname: path, state: { referrer: "inFlow" } });
    }

    if (UserPresenter.isPaid(currentUser)) {
      return push({ pathname: makeViewPath, state: { referrer: "inFlow" } });
    }
    const path = MakePresenter.isDraft(make) ? makePreviewPath : makeViewPath;
    return push({ pathname: path, state: { referrer: "inFlow" } });
  };

  const saveMakeAndGo = ({ roles, templateId, makeThumb, shareThumb }) =>
    ensureCurrentUser().then((currentUser) => {
      const isPreview =
        UserPresenter.isAnonymous(currentUser) ||
        (!UserPresenter.isPaid(currentUser) && TemplateGroupPresenter.premium(templateGroup));
      const renderMp4 = !isPreview;

      saveMake({ roles, templateId, makeThumb, shareThumb, renderMp4 }).then(
        (make) => {
          saveMakeSuccess(currentUser, make);
          return redirectTo(make, currentUser);
        },
        (error) => {
          let message = "Oops! Something went wrong!";
          let errors = "UseSaveMakeAndGo.js: Make Creation Error: ";

          if (error) {
            error.forEach((err) => {
              errors += err;
              if (err.includes("too few castings") || err.includes("head: can't be blank")) {
                message = "This card needs more people! Cast another face!";
              }
            });
          } else {
            errors += "Unknown Error";
          }

          addErrorNotification(message);
          newRelic(errors);
          jjLogger.log(errors);
        },
      );
    });

  return { saveMakeAndGo };
};

export default useSaveMakeAndGo;
